import { IS_MOBILE } from "const/common";
import Image from "next/image";
import { useEffect, useState } from "react";

const UIScreens = () => {
  const [isMobile, setIsMobile] = useState();
  useEffect(() => {
    setIsMobile(IS_MOBILE(600));
  }, []);
  return (
    <>
      <div className="pt-16 bg-black">
        <div className="py-16 px-4 md:p-16 rounded-t-10 bg-gradient-kyc-ui-screen">
          <h2 className="text-5xl md:text-4xl xl:text-5xl font-medium font-ubuntu text-white xl:p-16">
            <span className="font-ubuntu">UI Screens</span>
          </h2>
        </div>
      </div>
      {isMobile ? (
        <div className="bg-black p-4 overflow-hidden">
          <h3 className="text-2xl font-medium text-white">
            <span className="font-ubuntu">Home Screen</span>
          </h3>
          <div className="flex justify-center py-8">
            <Image
              alt="KYC App prompting user to give the review of vendor"
              src="/assets/case-study/kyc/screen.webp"
              width={655}
              height={1299}
            />
          </div>
          <p className="pt-4 text-xs font-light text-white text-left mb-4">
            <span className="font-ubuntu">
              When users start writing about their existing & upcoming
              customers, then & then only others will be able to get reviews;
              that is how this app&apos;s purpose will be achieved.
            </span>
          </p>
          <div className="py-8">
            <p className="py-4 text-xs font-light text-white text-left">
              <span className="font-ubuntu">
                In this screen, we majorly focused on the “Write a Review” CTA.
                The intention was to push users to write reviews about their
                past good/bad experiences.
                <br />
              </span>
            </p>
            <p className="py-4 text-xs font-light text-white text-left">
              <span className="font-ubuntu">
                The navigation bar along with the Home screen covering:-
              </span>
              <ul className="p-0">
                <li className="text-xs font-light">
                  <span className="font-ubuntu">
                    - &nbsp; Previous listing Screen
                  </span>
                </li>
                <li className="text-xs font-light">
                  <span className="font-ubuntu">
                    - &nbsp; Prioritization Que
                  </span>
                </li>
                <li className="text-xs font-light">
                  <span className="font-ubuntu">
                    - &nbsp;Favourite listing Screen
                  </span>
                </li>
              </ul>
            </p>
          </div>
        </div>
      ) : (
        <div className="bg-black md:pb-60 xl:py-16">
          <div className="bg-[#131313] mb-8 xl:my-8 h-[30rem] flex justify-around items-center">
            <div className="md:w-[44%] xl:w-[30%] text-left">
              <h3 className="text-2xl font-medium text-white md:pl-8 xl:pl-16">
                <span className="font-ubuntu">Home Screens</span>
              </h3>
              <p className="text-base font-light text-white md:pt-4 md:pl-8 xl:py-4 xl:px-16 text-left">
                <span className="font-ubuntu">
                  When users start writing about their existing & upcoming
                  customers, then & then only others will be able to get
                  reviews; that is how this app&apos;s purpose will be achieved.
                </span>
              </p>
            </div>
            <div className="md:w-[44%] xl:w-[30%] flex justify-center">
              <Image
                alt="KYC App prompting user to give the review of vendor"
                src="/assets/case-study/kyc/screen.webp"
                width={430}
                height={853}
              />
            </div>
            <div className="md:w-[44%] xl:w-[30%]">
              <p className="text-base font-light text-white md:p-4 xl:py-4 xl:px-16 text-left">
                <span className="font-ubuntu">
                  In this screen, we majorly focused on the “Write a Review”
                  CTA. The intention was to push users to write reviews about
                  their past good/bad experiences.
                  <br />
                </span>
              </p>
              <div className="text-base font-light text-white font-ubuntu md:p-4 xl:py-4 xl:px-16 text-left">
                <span className="font-ubuntu">
                  The navigation bar along with the Home screen covering:-
                </span>
                <ul className="p-0">
                  <li className="text-base font-light font-ubuntu">
                    <span className="font-ubuntu">
                      -&nbsp; Previous listing Screen
                    </span>
                  </li>
                  <li>
                    <span className="font-ubuntu">
                      -&nbsp;Prioritization Que
                    </span>
                  </li>
                  <li>
                    <span className="font-ubuntu">
                      -&nbsp; Favourite listing Screen
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="py-32 px-16 md:pt-72 md:px-16 md:pb-16 xl:py-72 xl:px-16 bg-black"></div>
      <div className="pt-16 px-4 xl:pt-16 xl:px-16">
        <div className="flex flex-col md:flex-row">
          <div className="text-center -mt-80 w-full md:w-4/12 md:pr-3">
            <div className="flex justify-center fs-0">
              <Image
                alt="KYC app screen showing previous ratings and reviews of a vendor"
                src="/assets/case-study/kyc/previous-listing.webp"
                width={304}
                height={856}
              />
            </div>
            <div>
              <h4 className="text-lg font-medium mt-8 mb-2">
                <span className="font-ubuntu">Previous listing Screen</span>
              </h4>
              <p className="text-xs md:text-sm xl:text-base font-light">
                <span className="font-ubuntu">
                  Here one can get all the previous listings they have ever
                  added.
                </span>
              </p>
            </div>
          </div>
          <div className="text-center mt-24 pb-[26rem] md:-mt-[30rem] md:pb-0 w-full md:w-4/12 md:pr-3">
            <div className="flex justify-center fs-0">
              <Image
                alt="KYC app screen showing Prioritization Que screen of a vendor"
                src="/assets/case-study/kyc/que.webp"
                width={304}
                height={759}
              />
            </div>
            <div>
              <h4 className="text-lg font-medium font-ubuntu mt-8 mb-2">
                <span className="font-ubuntu">Prioritization Que</span>
              </h4>
              <p className="text-xs md:text-sm xl:text-base font-light font-ubuntu">
                <span className="font-ubuntu">
                  This feature reduces the user’s customer searching time by
                  listing out all the customers they are connecting with through
                  calls or any medium via phone. In that case, the app will show
                  that particular customer’s rating on a popup (if that customer
                  has been previously rated).
                </span>
              </p>
            </div>
          </div>
          <div className="text-center -mt-80 w-full md:w-4/12">
            <div className="flex justify-center">
              <Image
                alt="KYC app screen showing favorite listing screen of a vendor"
                src="/assets/case-study/kyc/favorite.webp"
                width={304}
                height={856}
              />
            </div>
            <div className="text-xs md:text-sm xl:text-base font-light">
              <h4 className="text-lg font-medium font-ubuntu mt-8 mb-2">
                <span className="font-ubuntu">Favourite listing Screen</span>
              </h4>
              <p className="text-xs md:text-sm xl:text-base font-light">
                <span className="font-ubuntu">
                  One can save customers on this list with whom they want to
                  work in future also.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="px-8 relative pt-80 flex justify-center mx-4 xl:mx-8">
        <div className="bg-bright-navy-blue rounded-7.5 absolute h-auto w-fit -mt-40 overflow-hidden top-56 md:top-auto">
          <div className="flex flex-col md:flex-row justify-end">
            <div className="w-full md:w-1/2 flex items-end">
              <div className="py-8 px-4 md:pt-4 md:pb-4 md:pl-4 md:pr-0 xl:pt-16 xl:pb-24 xl:pl-24">
                <h2 className="text-3xl md:text-4xl xl:text-5xl font-medium text-white mb-2">
                  <span className="font-ubuntu">We made it so simple.</span>
                </h2>
                <p className="text-xs md:text-sm xl:text-base font-normal text-white mb-4">
                  <span className="font-ubuntu">
                    Providing feedback gets tedious if we get a lengthy form to
                    fill. As we had a few points already listed which anyone
                    would want to know about Clients, we provided it in check
                    box format along with the basic minimum profile information.
                  </span>
                </p>
                <p className="text-xs md:text-sm xl:text-base font-normal text-white mb-4">
                  <span className="font-ubuntu">
                    In case someone needs to add extra information (which adds
                    more clarity about the client to others), they would be able
                    to write a description box along with giving rating stars.
                  </span>
                </p>
              </div>
            </div>
            {isMobile ? (
              <div className="w-full md:w-1/2">
                <div className='fs-0'>
                  <Image
                    alt="mockup"
                    src="/assets/case-study/kyc/mobile-mockup.webp"
                    width={989}
                    height={1237}
                  />
                </div>
              </div>
            ) : (
              <div className="w-full md:w-1/2 bg-[url(/assets/case-study/kyc/card-back.webp)] xl:bg-center bg-cover bg-no-repeat md:h-[42vh] xl:h-[70vh]"></div>
            )}
          </div>
        </div>
      </div>
      <div className="py-32 px-16 md:pt-72 md:px-16 md:pb-16 xl:py-72 xl:px-16 bg-black"></div>
      <div className="pt-72 px-4 pb-16 md:1py-16 md:px-8 xl:p-16 bg-black">
        <h3 className="text-2xl font-medium text-white md:pl-8 xl:pl-16">
          <span className="font-ubuntu">More Screens</span>
        </h3>
        <div>
          {isMobile ? (
            <div className="fs-0 flex justify-center">
              <Image
                alt="Many user interface screenshots of KYC app, including Thank you page, Sign up page, Login page, 2 factor authentication, Edit profile page."
                src={"/assets/case-study/kyc/more-screen-mobile.webp"}
                width={341}
                height={1809}
              />
            </div>
          ) : (
            <div className="fs-0 flex justify-center">
              <Image
                alt="Many user interface screenshots of KYC app, including Thank you page, Sign up page, Login page, 2 factor authentication, Edit profile page.
              "
                src={"/assets/case-study/kyc/more-screen.webp"}
                width={1340}
                height={1902}
              />
            </div>
          )}
        </div>
      </div>
      <div className="bg-[url(/assets/case-study/kyc/girl.webp)] bg-cover bg-top md:bg-center h-[35vh] md:h-[65vh] xl:h-screen bg-no-repeat"></div>
    </>
  );
};

export default UIScreens;
